module.exports = __webpack_public_path__ + "img/GartenLunch.f11382c8.svg";